import { Youtube } from "lucide-react";
import { FadeUp } from "../components/Reveal";
import { FlameInitial } from "../components/FlameInitial";
import { CornerWebs } from "../components/CornerWebs";
import { JoinSection } from "../components/JoinSection";

const YOUTUBE_CHANNEL = "https://www.youtube.com/@TattooedAbroad";

const SHORTS = [
  {
    id: "deIYZKaZsqA",
    title: "Tattooed Abroad — show introduction and call to action",
  },
  {
    id: "ieZgZwpwB6Y",
    title: "Tattooed Abroad — personal story about new tattoos on old hands",
  },
];

const ShortEmbed = ({ video }) => (
  <div
    data-testid="short-embed"
    className="relative overflow-hidden border border-white/10 bg-surface/40 transition-colors duration-500 hover:border-flame/60"
  >
    <div className="relative aspect-[9/16] w-full">
      <iframe
        src={`https://www.youtube.com/embed/${video.id}`}
        title={video.title}
        loading="lazy"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute inset-0 h-full w-full"
      />
    </div>
  </div>
);

export default function Videos() {
  return (
    <>
      <section className="relative overflow-hidden pt-36 pb-16">
        <CornerWebs />
        <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[600px] -translate-x-1/2 rounded-full bg-flame opacity-10 blur-[120px]" />
        <div className="relative z-10 mx-auto w-full max-w-7xl px-6 text-center md:px-10">
          <FadeUp>
            <p className="font-gothic text-xs uppercase tracking-[0.35em] text-flame">Watch</p>
            <h1 className="mt-5 font-display text-5xl font-light tracking-tight text-white md:text-7xl">
              <FlameInitial letter="V" />ideos &amp; <FlameInitial letter="C" />lips
            </h1>
            <p className="mx-auto mt-6 max-w-2xl font-body text-lg leading-relaxed text-white/60">
              A first look at Tattooed Abroad—tattoos, travel, and the stories behind the ink.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="w-full px-6 pb-16 md:px-10 md:pb-20">
        <div className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-8 sm:flex-row">
          {SHORTS.map((video, i) => (
            <FadeUp key={video.id} delay={i * 0.12} className="w-full max-w-[320px]">
              <ShortEmbed video={video} />
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="relative overflow-hidden pb-24 md:pb-32">
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[220px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame opacity-10 blur-[120px]" />
        <div className="relative z-10 mx-auto max-w-3xl px-6 text-center md:px-10">
          <FadeUp>
            <p className="font-gothic text-sm uppercase tracking-[0.35em] text-flame md:text-base">
              Journeys Written in Skin.
            </p>
            <div className="mt-8">
              <a
                href={YOUTUBE_CHANNEL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="videos-subscribe-youtube"
                className="inline-flex items-center gap-3 bg-flame px-8 py-4 font-body text-xs uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-fire"
              >
                <Youtube size={18} /> Subscribe on YouTube
              </a>
            </div>
          </FadeUp>
        </div>
      </section>

      <JoinSection source="videos" />
    </>
  );
}
